import React, {Component} from 'react'
import {InputForm} from "../InputForm";
import PropTypes from "prop-types";
import DataGridRowCell from "./DataGridRowCell";

export default class DataGridRow extends Component {
    static propTypes = {
        /**
         * make item active (change background color to gray)
         */
        active: PropTypes.bool,
        /**
         * add checkbox to content & make item selectable
         * (this value will be set automatically by the parent component (DataGrid),
         * do not change this value if you are not sure what you are doing)
         */
        withCheckbox: PropTypes.bool,
        /**
         * add additional class name to block wrapper (tr)
         */
        additionalClass: PropTypes.string,
        /**
         * item value (should be unical)
         */
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        /**
         * on item select callback (this value will be set automatically by the parent component (DataGrid), do not change this value if you are not sure what you are doing)
         */
        onItemSelect: PropTypes.func,
        /**
         * select item by default
         */
        selected: PropTypes.bool,
        /**
         * Component inner (can be anything, but recommended to use DataGridRowCell)
         */
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ])
    };

    static defaultProps = {
        selected: false
    };

    constructor(props) {
        super(props);

        this.checkboxRef = React.createRef();
        this.selectItem.bind(this);

        this.getRowCheckbox = this.getRowCheckbox.bind(this);
        this.getRowClasses = this.getRowClasses.bind(this);
        this.getRowData = this.getRowData.bind(this);
    }

    async selectItem() {
        if(this.props.onItemSelect) {
            this.props.onItemSelect(this.props.value);
        }
    }

    getRowCheckbox() {
        const {withCheckbox, selected} = this.props;

        if(!withCheckbox) {
            return null;
        }

        return (
            <td className={`data-grid__checkbox`}>
                <InputForm
                    type={'checkbox'}
                    label={false}
                    value={selected}
                    ref={this.checkboxRef}
                    onClick={()=>{
                        this.selectItem()
                    }}
                />
            </td>
        )
    }

    getRowData() {
        const {children} = this.props;

        const itemCount = Array.isArray(children) ? children.length : 1;

        return React.Children.map(children, (child) => {
            if(child && child.type && child.type === DataGridRowCell) {
                return React.cloneElement(child, {
                    colSpan: itemCount === 1 ? '100%' : (child.props.colSpan || null),
                })
            } else {
                return child
            }
        });
    }

    getRowClasses() {
        const {active, withCheckbox, additionalClass, className} = this.props;

        const classes = [];

        if(active) {
            classes.push('active');
        }
        if(withCheckbox) {
            classes.push('with--checkbox')
        }
        if(additionalClass) {
            classes.push(additionalClass)
        }
        if(className) {
            classes.push(className)
        }

        return classes;
    }

    render() {
        const reservedOptionNames = ['active','withCheckbox','additionalClass','className','children','selected', 'onItemSelect', 'value'];

        const {...rest} = this.props;

        const data = this.getRowData();
        const checkboxBlock = this.getRowCheckbox();

        const classNames = this.getRowClasses();

        const restOptions = {};

        for (const [key, value] of Object.entries(rest)) {
            if(!reservedOptionNames.includes(key)) {
                restOptions[key] = value;
            }
        }

        return (
            <tr className={classNames.join(' ')} {...restOptions}>
                {checkboxBlock}
                {data}
            </tr>
        )
    }
}
